var React = require('react');

function IconCycleCircleSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M508.8 63.9c-245.8 0-445 199.2-445 445s199.2 445 445 445 445-199.2 445-445c0-245.7-199.2-445-445-445zm-74.5 425.7c1.6 1.6 1.6 4.1 0 5.6-4.4 4.5-12.9 12.8-16 15.9-.7.7-1.7 1.1-2.8 1.1h-93.9l-1 1c.5 105.3 85.8 190.6 191.6 190.6 37.6 0 72.9-11.1 102.5-29.9 1.6-1 3.7-.8 5 .5l40.4 40.4c1.8 1.8 1.5 4.7-.5 6.1-60.3 42.9-140.4 60.5-224 35.5-80.2-24-144.1-87.4-167.6-168.1-25-84.5-7.4-163.7 34.9-223.9 1.4-2 4.4-2.3 6.1-.5m281.1 170.3c-1.5-1.6-1.6-4.1 0-5.6 4.4-4.5 12.9-12.8 16-15.9.7-.7 1.7-1.1 2.8-1.1h93.9c0-105.8-85.9-191.6-191.6-191.6-37.6 0-72.5 11.1-102 29.5-1.6 1-3.6.8-5-.6l-40.4-40.4c-1.8-1.8-1.5-4.7.5-6.1 60.3-42.4 138.9-59.5 222.4-35.5 80.7 23.5 144.6 86.9 168.1 167.6 24.5 83.5 7.4 163.2-34.9 223.4-1.4 2-4.4 2.3-6.1.5"}));
}

IconCycleCircleSolid.displayName = "IconCycleCircleSolid";

IconCycleCircleSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconCycleCircleSolid;

IconCycleCircleSolid.default = IconCycleCircleSolid;
